<template>
    <div id="tyres-wrapper" class="tyres col-12 mb-3">
        <div class="custom-tyre-size-content border-2 border-secondary" v-if="tyreSizeContent">
            <div class="bg-secondary p-2" v-if="tyreSizeContent?.h1">
                <h1 class="fs-4 mb-0 text-white">{{ tyreSizeContent.h1 ? tyreSizeContent.h1 : customTyreUrl + ' Tyres' }}</h1>
            </div>
            <div v-if="tyreSizeContent?.content" class="pt-3 px-3">
                <div v-html="tyreSizeContent.content"></div>
            </div>
        </div>
        <h2 v-if="tyreSizeContent?.h1" class="text-start my-3 d-inline-block">We found {{ totalTyres }} Tyres for size: {{ tyreSize }}</h2>
        <h1 v-else class="text-start my-3 d-inline-block h2">We found {{ totalTyres }} Tyres for size: {{ tyreSize }}</h1>
        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
            <div v-for="tyre, key in tyresWithAds" class="col d-flex align-items-stretch" :key="key">
                <tyre
                    v-if="(typeof(tyre.st_code) != 'undefined')"
                    :featured="false"
                    :tyre="tyre"
                    :basket="basket"
                    :banners="banners"
                    :postcode="postcode"
                    :pay-with-paypal="payWithPaypal"
                ></tyre>
                <tyre-ad :ad="tyre" v-else></tyre-ad>
            </div>
            <InfiniteLoading
                :distance="500"
                :identifier="infiniteReset"
                ref="infiniteLoading"
                @infinite="this.$parent.handleInfiniteScroll"
            >
                <template #error><p>That's it, no more tyres found.</p></template>
                <template #spinner><p><i class="fad fa-tire fa-lg fa-spin"></i> loading more tyres..</p></template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script>
    import InfiniteLoading from "v3-infinite-loading";
    import "v3-infinite-loading/lib/style.css";

    export default {
        props: [
            'tyres',
            'basket',
            'banners',
            'featuredTyres',
            'totalTyres',
            'tyreSize',
            'infiniteReset',
            'postcode',
            'tyreAds',
            'tyreSizeContent',
            'payWithPaypal'
        ],
        components: {
            InfiniteLoading
        },
        data() {
            return {
				tyresWithAds: this.tyres
            }
        },
        created() {
        },
        mounted() {
        },
        update() {
        },
        methods: {
			//This function is used to merge Adverts (banners) into returned tyres
			mergeAdsIntoTyres() {
				var vm = this;
				var mergedTyres = [];
				var counter = 0;
				var adCounter = 0;

                if(Object.keys(this.tyreAds).length > 0) {
                    //If there are tyreAds, loop through and insert them into tyres
                    _.forEach(this.tyres, function(tyre, key) {
                        //Insert ad after every 5 tyres.
                        if(counter % 5 == 0 && counter > 0) {
                            var ad = vm.tyreAds[adCounter];
                            //Place add at this counter
                            mergedTyres[counter] = ad;
                            adCounter++;
                            //Place loop tyre after ad
                            counter++;
                            mergedTyres[counter] = tyre;

                            if(adCounter > Object.keys(vm.tyreAds).length -1) {
                                adCounter = 0;
                            }
                        }
                        else {
                            mergedTyres[counter] = tyre;
                        }
                        counter++;
                    });
                }
                else {
                    mergedTyres = this.tyres;
                }

				return mergedTyres;
			}
        },
        watch: {
            tyres: {
                deep: true,
                handler() {
                    this.tyresWithAds = this.mergeAdsIntoTyres();
                }
            }
        },
        computed: {
        }
    }
</script>
<style lang="scss" scoped>
    .custom-tyre-size-content {
        border: 1px solid #0A2463;
        p {
            margin-bottom: 0 !important;
        }
    }
</style>